import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./nav-pane-content.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./nav-pane-content.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { NavConstants } from "../nav.constants";
import { AppControllerService } from "../../../app-controller.service";
import { Router } from "@angular/router";
import { UserInformationService } from "../../../shared/services/user/user-information.service";
import { AuthService } from "../../../shared/services/auth/auth.service";
import { SystemModuleSettingsService } from "../../../shared/services/system-module-settings.service";
import { CreateApplicationRoutingConstants } from "../../../create-application/create-application-routing.constants";
import { SearchApplicationsRoutingConstants } from "../../../search-applications/search-applications-routing.constants";
import { CommonPopUpComponent } from "../../../../../../afla-common/src/lib/components/common-pop-up/common-pop-up.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { SelectedApplicationService } from "../../../shared/services/selected-application/selected-application.service";
import { NavPanService } from "./nav-pan.service";
import { DocumentsAndInformationRoutingConstants } from "../../../documents-and-information/documents-and-information-routing.constants";
import { SessionStorageService } from "../../../shared/services/storage/session-storage.service";
import { LocalStorageEnum } from "../../../shared/services/storage/local-storage-constants";
import { ApplicationCreateService } from "../../../create-application/shared/application-create.service";
import { AppConfig } from "../../../app.config";
import { RequestStatusService } from "../../../shared/services/request-status/request-status.service";
import { AutoUnsubPortal } from "../../../shared/decorators/autounsub-portal.decorator";
import { LocalStorageService } from "../../../shared/services/storage/local-storage.service";
import { SystemSettingService } from "../../../shared/services/system-setting/system-setting.service";
let NavPaneContentComponent = class NavPaneContentComponent {
    userInformationService;
    appControllerService;
    authService;
    router;
    applicationCreateService;
    sessionStorageService;
    changeDetectorRef;
    selectedApplicationService;
    systemModuleSettingsService;
    systemSettingsService;
    navService;
    modalService;
    localStorage;
    requestStatusService;
    modulesLink = AppRoutingConstants.ROUTE_SEPERATOR;
    homeLinkText = NavConstants.HOME_LINK_TEXT;
    logoutLinkText = NavConstants.LOGOUT_LINK_TEXT;
    organisationId;
    activeId = "";
    selectedModuleID;
    isAuthenticated = false;
    isSystemModuleSettingsFetched = false;
    selectMunicipalityText = "";
    municipalities = [];
    selectedMunicipality;
    applicationTypes;
    selectedApplicationType;
    applications = [];
    selectMunicipalityLabel = NavConstants.SELECT_MUNICIPALITY_LABEL;
    selectApplicationLabel = NavConstants.SELECT_APPLICATION_LABEL;
    viewDocumentationText = NavConstants.VIEW_DOCUMENTATION_TEXT;
    createApplicationText = NavConstants.CREATE_APPLICATION_TEXT;
    searchMyApplicationText = NavConstants.SEARCH_MY_APPLICATION_TEXT;
    selectAnOptionText = NavConstants.PLEASE_SELECT_AN_OPTION;
    logo = "";
    loadedApplicationTypesMap = new Map();
    dialogTitle = NavConstants.INCOMPLETE_APPLICATIONS_TITLE;
    dialogMessage = NavConstants.INCOMPLETE_APPLICATIONS_MESSAGE;
    modalBodyOptions = NavConstants.MODAL_OPTIONS;
    selectedMunicipalityId = null;
    selectedApplicationTypeId = null;
    redirectUrl = "";
    userInformationServiceSubscription;
    isAuthenticatedSubscription;
    navServiceSubscription;
    systemModuleSettingsServiceSubscription;
    navServiceApplicationTypesSubscription;
    navServiceSelectedApplicationSubscription;
    constructor(userInformationService, appControllerService, authService, router, applicationCreateService, sessionStorageService, changeDetectorRef, selectedApplicationService, systemModuleSettingsService, systemSettingsService, navService, modalService, localStorage, requestStatusService) {
        this.userInformationService = userInformationService;
        this.appControllerService = appControllerService;
        this.authService = authService;
        this.router = router;
        this.applicationCreateService = applicationCreateService;
        this.sessionStorageService = sessionStorageService;
        this.changeDetectorRef = changeDetectorRef;
        this.selectedApplicationService = selectedApplicationService;
        this.systemModuleSettingsService = systemModuleSettingsService;
        this.systemSettingsService = systemSettingsService;
        this.navService = navService;
        this.modalService = modalService;
        this.localStorage = localStorage;
        this.requestStatusService = requestStatusService;
    }
    ngOnInit() {
        this.redirectToDefaultLink();
        this.subscribeToConfigSubject();
        this.loadMunicipalities();
        this.listenForAuthentication();
        this.listenForModuleFetch();
        this.showDefaultModule();
        this.subscribeToSelectedApplicationFromSearchPage();
    }
    redirectToDefaultLink() {
        this.authService.$isAuthenticated.subscribe(authenticated => {
            if (authenticated === true && this.localStorage.get(LocalStorageEnum.Url)) {
                let url = this.localStorage.get(LocalStorageEnum.Url).toString();
                this.localStorage.set(LocalStorageEnum.Url, null);
                this.localStorage.remove(LocalStorageEnum.Url);
                url = url.replace(/"/g, "");
                url = url.replace("/aflaportal", "");
                if (this.extractModulId(url))
                    this.redirectUrl = url;
                // this.router.navigateByUrl(url);
            }
        });
        this.redirectUrl = "";
    }
    extractModulId(url) {
        const urlArray = url.split("/");
        const moduleId = +urlArray[1];
        if (urlArray.length >= 4) {
            const jobId = +urlArray[3];
            this.appControllerService.selectedJobID = jobId;
        }
        if (moduleId) {
            this.appControllerService.setSelectedModule(moduleId);
            return true;
        }
        return false;
    }
    logout() {
        this.authService.logOutRedirect();
        // this.authService.unAuthenticate();
    }
    onSearchApplicationClicked() {
        this.router.navigate([
            AppRoutingConstants.createRouteToView(SearchApplicationsRoutingConstants.SEARCH_APPLICATIONS_ROUTE)
        ]).then(() => {
            // this.clearResetDropdowns();
        });
    }
    onCreateApplicationClicked() {
        if (this.systemSettingsService.isMaintenanceModeEnabled() && !this.systemSettingsService.getMaintenanceAcknowledged() && !this.router.url.includes("/logout")) {
            this.router.navigateByUrl(`/${AppRoutingConstants.MAINTENANCE_PATH}`);
        }
        else {
            this.appControllerService.setSelectedModule(this.selectedModuleID);
            this.appControllerService.setModuleAllowResubmission();
            this.checkIncompleteApplications();
        }
    }
    checkIncompleteApplications() {
        this.requestStatusService.showBusySpinner("Searching incomplete applications");
        this.userInformationServiceSubscription = this.userInformationService.hasOpenPortalApplications(Number(this.appControllerService.selectedModuleID)).subscribe(result => {
            this.requestStatusService.removeBusySpinner("Searching incomplete applications");
            if (result.value === true) {
                this.openIncompleteApplicationsDialog();
            }
            else {
                this.proceedToCreateApplications();
            }
        });
    }
    onViewDocumentationClicked() {
        this.router.navigate([
            AppRoutingConstants.createRouteToView(this.appControllerService.selectedModuleID, DocumentsAndInformationRoutingConstants.VIEW_DOCUMENTS_AND_INFORMATION_ROUTE)
        ]);
    }
    selectMunicipality(event) {
        const input = event.target.value;
        this.selectedApplicationType = null;
        this.applicationTypes = null;
        if (!input) {
            return;
        }
        this.selectedMunicipality = this.municipalities.find(m => m.id === +input);
        if (!this.selectedMunicipality)
            return;
        this.appControllerService.selectedOrganisationID(this.selectedMunicipality.id);
        this.getApplicationTypes(this.selectedMunicipality.id);
    }
    selectApplicationType(event) {
        const input = event.target.value;
        this.selectedApplicationType = null;
        if (!input)
            return;
        this.selectedApplicationType = this.applicationTypes.find(m => m.id === +input);
        if (!this.selectedApplicationType)
            return;
        this.selectedModuleID = this.selectedApplicationType.id;
        this.appControllerService.setSelectedModule(this.selectedApplicationType.id);
        this.appControllerService.setModuleAllowResubmission();
        if (this.systemSettingsService.isMaintenanceModeEnabled() && !this.systemSettingsService.getMaintenanceAcknowledged() && !this.router.url.includes("/logout")) {
            this.router.navigateByUrl(`/${AppRoutingConstants.MAINTENANCE_PATH}`);
        }
        else {
            this.router.navigate(["/"]);
        }
    }
    proceedToCreateApplications() {
        this.selectedApplicationService.setSelectedApplication(null);
        this.sessionStorageService.remove(LocalStorageEnum.SelectedJobID);
        this.sessionStorageService.set(LocalStorageEnum.SelectedModuleID, this.appControllerService.selectedModuleID);
        this.selectedApplicationService.setIncompleteJobId(0);
        this.applicationCreateService.setSelectGoToStep(0);
        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
            this.router.navigate([AppRoutingConstants.createRouteToView(this.appControllerService.selectedModuleID, CreateApplicationRoutingConstants.CREATE_APPLICATION_ROUTE)]);
        });
    }
    openIncompleteApplicationsDialog() {
        const dialogRef = this.modalService.open(CommonPopUpComponent, this.modalBodyOptions);
        dialogRef.componentInstance.title = this.dialogTitle;
        dialogRef.componentInstance.contentMessage = this.dialogMessage;
        dialogRef.componentInstance.updateBtnPlaceholder = SharedConstants.OK_LABEL;
        dialogRef.componentInstance.cancelBtnPlaceholder = SharedConstants.CANCEL_LABEL;
        dialogRef.componentInstance.data = true;
        dialogRef.result.then((proceed) => {
            this.changeDetectorRef.markForCheck();
            if (proceed) {
                this.proceedToCreateApplications();
            }
            else {
                this.onSearchApplicationClicked();
            }
        });
    }
    showDefaultModule() {
        // function will show all modules by default if user has only 1 organisation assigned
        const activePanel = "panel-0";
        this.activeId = activePanel;
    }
    listenForAuthentication() {
        this.isAuthenticatedSubscription = this.authService.$isAuthenticated.subscribe(result => {
            if (this.isAuthenticated === false) {
                this.isAuthenticated = result;
                this.changeDetectorRef.detectChanges();
            }
        });
    }
    loadMunicipalities() {
        this.isAuthenticatedSubscription = this.userInformationService.$isUserInformationLoaded.subscribe(connected => {
            if (connected) {
                this.navServiceSubscription = this.navService.getMunicipalities().subscribe(mun => {
                    this.municipalities = mun;
                    this.appControllerService.organisations = this.municipalities;
                    if (this.municipalities.length > 1 && this.redirectUrl == "") {
                        this.navService.isNavigationBarLoaded$.next(true);
                    }
                    if (this.municipalities.length === 1) {
                        this.navService.isNavigationBarLoaded$.next(true);
                        this.selectedMunicipality = this.municipalities[0];
                        this.selectedMunicipalityId = this.selectedMunicipality.id;
                        this.getApplicationTypes(this.selectedMunicipality.id);
                        this.appControllerService.selectedOrganisationID(this.municipalities[0].id);
                    }
                    else if (this.redirectUrl !== "") {
                        this.navServiceSubscription = this.navService.getMunicipalitiesByModuleId(+this.appControllerService.selectedModuleID).subscribe(moduleMunicipalities => {
                            if (this.municipalities.length > 0 && moduleMunicipalities.length > 0) {
                                this.navService.isNavigationBarLoaded$.next(true);
                                const moduleMunicipality = this.municipalities.find(p => p.id === moduleMunicipalities[0].id);
                                this.selectedMunicipality = moduleMunicipality;
                                this.selectedMunicipalityId = moduleMunicipality.id;
                                this.getApplicationTypes(moduleMunicipality.id);
                                this.appControllerService.selectedOrganisationID(moduleMunicipality.id);
                            }
                            this.changeDetectorRef.markForCheck();
                        });
                    }
                    this.changeDetectorRef.markForCheck();
                });
            }
        });
    }
    getApplicationTypes(municipalityId) {
        if (this.loadedApplicationTypesMap.has(municipalityId)) {
            this.applicationTypes = this.loadedApplicationTypesMap.get(municipalityId);
            if (this.applicationTypes.length === 1) {
                this.selectedApplicationType = this.applicationTypes[0];
                this.selectedApplicationTypeId = this.selectedApplicationType.id;
                this.appControllerService.setSelectedModule(this.selectedApplicationType.id);
            }
            else if (this.redirectUrl !== "") {
                this.selectedApplicationTypeId = +this.appControllerService.selectedModuleID;
            }
            this.appControllerService.setModuleAllowResubmission();
            if (this.redirectUrl !== "") {
                const url = this.redirectUrl;
                this.redirectUrl = "";
                this.appControllerService.$donNotReloadLastUrlOnRefreshObservable.subscribe(donNotReload => {
                    if (!donNotReload) {
                        this.router.navigateByUrl(url);
                    }
                });
            }
            this.changeDetectorRef.detectChanges();
        }
        else {
            this.navServiceApplicationTypesSubscription = this.navService.getApplicationTypes(municipalityId).subscribe(appType => {
                this.applicationTypes = appType;
                this.appControllerService.modules = this.applicationTypes;
                if (this.applicationTypes.length === 1) {
                    this.selectedApplicationType = this.applicationTypes[0];
                    this.selectedApplicationTypeId = this.selectedApplicationType.id;
                    this.appControllerService.setSelectedModule(this.selectedApplicationType.id);
                }
                else if (this.redirectUrl !== "") {
                    this.selectedApplicationTypeId = +this.appControllerService.selectedModuleID;
                }
                this.appControllerService.setModuleAllowResubmission();
                this.loadedApplicationTypesMap.set(municipalityId, this.applicationTypes);
                if (this.redirectUrl !== "") {
                    const url = this.redirectUrl;
                    this.redirectUrl = "";
                    this.appControllerService.$donNotReloadLastUrlOnRefreshObservable.subscribe(donNotReload => {
                        if (!donNotReload) {
                            this.router.navigateByUrl(url);
                        }
                    });
                }
                this.changeDetectorRef.detectChanges();
            });
        }
    }
    subscribeToConfigSubject() {
        this.appControllerService.$configLoadedSubject.subscribe((configLoaded) => {
            if (configLoaded) {
                this.logo = AppConfig.settings.logoUrl;
                this.selectMunicipalityText = AppConfig.settings.selectMunicipalityText.text;
                this.changeDetectorRef.detectChanges();
            }
        });
    }
    listenForModuleFetch() {
        this.systemModuleSettingsServiceSubscription = this.systemModuleSettingsService.$systemModuleSettingsFetched.subscribe(result => {
            if (this.isSystemModuleSettingsFetched === false) {
                this.isSystemModuleSettingsFetched = result;
                this.changeDetectorRef.detectChanges();
            }
        });
    }
    subscribeToSelectedApplicationFromSearchPage() {
        this.navServiceSelectedApplicationSubscription = this.navService.selectedApplication$.subscribe({
            next: (application) => {
                if (application) {
                    this.setMunicipalityAndSelectedApplicationTypes(application);
                }
            }
        });
    }
    setMunicipalityAndSelectedApplicationTypes(application) {
        this.selectedMunicipality = this.municipalities.find(m => m.name === application.organisationName);
        this.selectedMunicipalityId = this.selectedMunicipality.id;
        this.navServiceApplicationTypesSubscription = this.navService.getApplicationTypes(this.selectedMunicipality.id).subscribe({
            next: (applicationTypes) => {
                if (applicationTypes.length > 0) {
                    this.applicationTypes = applicationTypes;
                    this.appControllerService.modules = this.applicationTypes;
                    this.selectedApplicationType = this.applicationTypes.find(applicationType => applicationType.name === application.applicationType);
                    if (this.selectedApplicationType !== undefined && this.selectedApplicationType !== null) {
                        this.selectedApplicationTypeId = this.selectedApplicationType.id;
                        this.loadedApplicationTypesMap.set(application.moduleId, this.applicationTypes);
                    }
                    else {
                        this.loadedApplicationTypesMap = new Map();
                    }
                    this.changeDetectorRef.detectChanges();
                }
            }
        });
    }
    clearResetDropdowns() {
        this.selectedApplicationType = null;
        this.selectedApplicationTypeId = null;
        this.selectedMunicipality = null;
        this.selectedMunicipalityId = null;
        this.changeDetectorRef.detectChanges();
    }
    static ctorParameters = () => [
        { type: UserInformationService },
        { type: AppControllerService },
        { type: AuthService },
        { type: Router },
        { type: ApplicationCreateService },
        { type: SessionStorageService },
        { type: ChangeDetectorRef },
        { type: SelectedApplicationService },
        { type: SystemModuleSettingsService },
        { type: SystemSettingService },
        { type: NavPanService },
        { type: NgbModal },
        { type: LocalStorageService },
        { type: RequestStatusService }
    ];
};
NavPaneContentComponent = __decorate([
    Component({
        selector: "app-nav-pane-content",
        providers: [],
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsubPortal()
], NavPaneContentComponent);
export { NavPaneContentComponent };
